import { Routes, Route, Navigate } from "react-router-dom";

import LandingPage from "./pages/LandingPage";
import DataListMain from "./pages/DataListMain";
import RequestFormMain from "./pages/RequestFormMain";
import LoginPage from "./pages/LoginPage";
import './GlobalStyle.css';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/nicdsign" replace />} />
        <Route path="/nicdsign" element={<LandingPage />} />
        {/* <Route path="/requestForm" element={<RequestFormMain />} /> */}
        <Route path="/dataList" element={<DataListMain />} />
        {/* <Route path="/admin" element={<LoginPage />} /> */}
        {/* <Route  path="/authorize" element={<FormComponent />} /> */}
        <Route path="*" element={<div>Page not found</div>} />
      </Routes>
    </>
  );
}

export default App;
